import PropTypes from 'prop-types';

import { IconButton } from '@mui/material';
import { MIcon } from '../../@material-extend';

const CopyButton = (props) => {
  const { disabled = true, handleClick } = props;

  return (
    <IconButton aria-label="delete" color="comete" disabled={disabled} onClick={handleClick}>
      <MIcon icon="content_copy" aria-label="copier" />
    </IconButton>
  );
};
CopyButton.propTypes = {
  disabled: PropTypes.bool,
  handleClick: PropTypes.func.isRequired
};

export default CopyButton;
